export interface ISystemLastHeartbeat {
    systemTime: Date;
}

export class SystemLastHeartbeat implements ISystemLastHeartbeat {
    systemTime: Date;

    constructor(systemTime: Date) {
        this.systemTime = systemTime;
    }
}



/** WEBPACK FOOTER **
 ** ./app/main/systemHealthRetriever/system-last-heart-beat.ts
 **/